import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { ProductFormService } from "../shared";

@Component({
  selector: "product-summary-form",
  templateUrl: "./product-summary-form.component.html",
  styleUrls: ["./product-summary-form.component.scss"],
})
export class ProductSummaryFormComponent {
  @Input() form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public formService: ProductFormService
  ) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-summary-form/product-summary-form.component.ts